import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Card, CardContent, CardHeader } from "@mui/material";

import { APIEndpoints } from "@/apis/endpoints";
import { T } from "@/components/LocalizedString";
import { extractErrorMessage } from "@/utils/misc";

const translateUserStatus = (userStatus: string) => {
  switch (userStatus) {
    case "To add":
      return T("To add");
    case "To deactivate":
      return T("To deactivate");
    case "To reactivate":
      return T("To reactivate");
    case "To update":
      return T("To update");
    case "Group change":
      return T("Group change");
    case "To link":
      return T("To link");
    default:
      return userStatus;
  }
};

export function Validation({ setStep, users }) {
  const [error, setError] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const { t } = useTranslation();
  const btnNextClicked = async () => {
    setError("");

    const usersToUpload = users.filter((user) => user.status !== "To delete");

    const accessToken = await getAccessTokenSilently();
    try {
      const response = await axios.post(
        APIEndpoints.SIMULATION + "/users/import/apply",
        usersToUpload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      const data = await response.data;

      if (data.error) {
        setError(data.error);
      } else {
        setStep(4);
      }
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };
  return (
    <Card>
      <CardHeader title={t("Import Users - Step 3/4: Validation")} />
      <CardContent>
        <div>
          {t("Please check that everything looks correct:")}
          <table className="table">
            <thead>
              <tr>
                <th scope="col">{t("Firstname")}</th>
                <th scope="col">{t("Lastname")}</th>
                <th scope="col">{t("Email")}</th>
                <th scope="col">{t("Language")}</th>
                <th scope="col">{t("Location")}</th>
                <th scope="col">{t("Timezone")}</th>
                <th scope="col">{t("Group")}</th>
                <th scope="col">{t("Status")}</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.email}>
                  <td>{user.firstname}</td>
                  <td>{user.lastname}</td>
                  <td>{user.email}</td>
                  <td>{user.language}</td>
                  <td>{user.location}</td>
                  <td>{user.timezone}</td>
                  <td>{user.group}</td>
                  <td
                    className={(() => {
                      switch (user.status) {
                        case "To add":
                          return "table-success";
                        case "To deactivate":
                          return "table-danger";
                        case "To reactivate":
                          return "table-warning";
                        case "To update":
                          return "table-info";
                        case "Group change":
                          return "table-info";
                        case "To link":
                          return "table-info";
                        default:
                          return "#FFFFFF";
                      }
                    })()}
                  >
                    {translateUserStatus(user.status)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {error !== "" && <div style={{ color: "red" }}>{error}</div>}
        <div>
          <Button variant="contained" onClick={btnNextClicked}>
            {t("Apply changes")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
